// extracted by mini-css-extract-plugin
export default {"retentionWrapper":"RetentionDetails_retentionWrapper__3ErcL"};